import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import GlobalHead from "@/components/GlobalHead";
import Navigation from "@/components/Navigation";
import TextureLayer from "@/components/TextureLayer";
import Footer from "@/components/Footer";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import { Toaster } from "@/components/ui/sonner";

const SPLASH_PRESS_RESET_MS = 420;
const INTERACTIVE_SELECTOR = 'a, button, [role="button"], .service-splash-button';

function App() {
  useEffect(() => {
    const handlePointerDown = (event) => {
      const target = event.target.closest(INTERACTIVE_SELECTOR);
      if (!target) return;

      const existingTimer = target.dataset.splashTimer;
      if (existingTimer) {
        window.clearTimeout(Number(existingTimer));
      }

      target.classList.add("splash-press-active");
      const timerId = window.setTimeout(() => {
        target.classList.remove("splash-press-active");
        delete target.dataset.splashTimer;
      }, SPLASH_PRESS_RESET_MS);
      target.dataset.splashTimer = String(timerId);
    };

    document.addEventListener("pointerdown", handlePointerDown, true);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
    };
  }, []);

  return (
    <div className="App relative min-h-screen bg-black overflow-x-hidden">
      <div className="water-splash-bg" />
      <div className="water-splash-overlay" />
      <div className="blackline-dim-overlay" />
      <div className="colorful-ambient-overlay" />
      <TextureLayer />
      <div className="relative z-10">
        <HelmetProvider>
          <BrowserRouter>
            <GlobalHead />
            <Navigation />
            <Routes>
              <Route path="/" element={<Services />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
            </Routes>
            <Footer />
          </BrowserRouter>
        </HelmetProvider>
      </div>
      <Toaster />
    </div>
  );
}

export default App;
